<template>
  <div>
    <v-container style="margin-top: 24px; margin-bottom: 80px; height: 76.9vh">
      <v-row class="justify-center">
        <v-col cols="12" sm="10" md="8" lg="6" class="text-left">
          <div class="text-h6 font-weight-black mb-6">分享{{ title }}</div>
          <div class="share-block mb-6">
            <div class="font-weight-black">二維條碼</div>
            <div class="d-flex align-center">
              <v-img
                :src="qrcodeImg"
                max-width="65"
                max-height="65"
                contain
              ></v-img>
              <span class="mx-4">點擊開啟Qrcode後，分享給好友</span>
              <v-spacer></v-spacer>
              <v-btn color="primary" large @click="qrDialog.open = true"
                >點擊放大</v-btn
              >
            </div>
          </div>
          <div class="share-block">
            <div class="font-weight-black">分享連結</div>
            <div class="text-body-2 mb-1">點擊複製按鈕後，分享給好友</div>
            <div class="d-flex align-center">
              <v-text-field
                v-model="shareUrl"
                filled
                hide-details="auto"
                type="text"
                dense
              >
                <template v-slot:append>
                  <v-icon>mdi-link</v-icon>
                </template>
              </v-text-field>
              <v-btn color="primary" large @click="CopyBoard">複製</v-btn>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <!--  #region 彈窗-->
    <v-dialog v-model="qrDialog.open" width="450">
      <v-card>
        <v-card-title class="text-h6 font-weight-black pt-4 pb-2">
          {{ qrDialog.title }}
          <v-spacer></v-spacer>
          <v-btn icon @click="qrDialog.open = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <div class="pa-4" align="center">
          <VueQRCode
            :text="shareUrl"
            :size="200"
            error-level="L"
            class="py-4"
          ></VueQRCode>
          <div class="text-h6 text-black font-weight-black">{{ title }}</div>
        </div>

        <v-card-actions class="pb-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="qrDialog.open = false">關閉</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- #endregion -->

    <!--  #region 提示條 -->
    <v-snackbar
      top
      v-model="snackbar.show"
      color="success"
      min-width="150"
      height="40"
      dense
      text
      :timeout="5000"
    >
      <v-icon color="success" class="mr-2">mdi-check-circle</v-icon>
      {{ snackbar.content }}
    </v-snackbar>
    <!-- #endregion -->
  </div>
</template>

<script>
import VueQRCode from "vue-qrcode-component";

export default {
  components: {
    VueQRCode,
  },
  data() {
    return {
      qrcodeImg: require("@/assets/image/serivceIcon/qrcode_icon.svg"),
      shareUrl: process.env.VUE_APP_MAIN_BASE_URL,
      qrDialog: {
        open: false,
        title: "分享二維條碼",
      },
      snackbar: {
        show: false,
        close: "關閉",
        content: "",
      },
      title: "小芋頭企業服務平台",
    };
  },
  methods: {
    CopyBoard() {
      let preWord = `邀請您參訪【${this.title}】網站 `;
      let href = preWord + this.shareUrl;
      this.$copyText(href)
        .then(() => {
          this.snackbar.show = true;
          this.snackbar.content = "連結已複製。";
        })
        .catch((err) => {
          console.log(err.text);
          this.snackbar.show = true;
          this.snackbar.content = "複製失敗，請手動複製。";
        });

      if (navigator.share && this.$store.state.userDevice.mobile) {
        navigator
          .share({
            title: "小芋頭平台",
            text: preWord,
            url: this.shareUrl,
          })
          .then(() => {})
          .catch(() => {});
      }
    },
  },
};
</script>

<style scoped>
.share-block {
  padding: 16px 21px 16px 16px;
  border-radius: 8px;
  background: #fafafa;
}
</style>
